/**
 * MapModeControl — segmented control for Plan, Operate, and 3D modes.
 */

import React from 'react';
import type { MapMode } from '../types/mapTypes';

interface MapModeControlProps {
  mode: MapMode;
  onChange: (mode: MapMode) => void;
}

const MODES: { key: MapMode; label: string; icon: string }[] = [
  { key: 'plan', label: 'Plan', icon: '📐' },
  { key: 'operate', label: 'Operate', icon: '📊' },
  { key: 'terrain3d', label: '3D', icon: '🏔️' },
];

export default function MapModeControl({ mode, onChange }: MapModeControlProps) {
  return (
    <div className="flex bg-white rounded-lg shadow-md border border-slate-200 overflow-hidden">
      {MODES.map((m) => (
        <button
          key={m.key}
          onClick={() => onChange(m.key)}
          title={`${m.label} mode`}
          className={`px-3 py-2 text-xs font-semibold transition-colors ${
            mode === m.key
              ? 'bg-emerald-600 text-white'
              : 'text-slate-500 hover:bg-slate-50 hover:text-slate-700'
          }`}
        >
          <span className="mr-1">{m.icon}</span>
          {m.label}
        </button>
      ))}
    </div>
  );
}
